import { ref, nextTick, watch } from '@nuxtjs/composition-api';
const isGPTWithoutIframeLoaded = ref(false);
export const initializeGPTWithoutIframe = (isMobile) => {
  if (!isGPTWithoutIframeLoaded.value) {
    const loadedAdUnitsCounts = ref(0);
    watch(isMobile, () => {
      loadedAdUnitsCounts.value = 0;
    });
    if (process.client) {
      nextTick(() => {
        window.addEventListener('message', (e) => {
          const eventName = e.data?.message || 'ignore';
          if (eventName === 'adContentAvailable') {
            if (e.data?.adUnit) {
              loadedAdUnitsCounts.value = loadedAdUnitsCounts.value + 1;
              const adElement = document.querySelector(`#${e.data.adUnit}_${loadedAdUnitsCounts.value}`);
              if (adElement) {
                adElement.innerHTML = e.data?.content;
              }
            }
          }
        });
        isGPTWithoutIframeLoaded.value = true;
      });
    }
  }
};
